import { brandCodeMap } from '@/constants';
import { comm, base } from '../base';
// export const tabs = {
//   tabs: {
//     navBgc: base.color.c0023,
//     tabColor: base.color.c0014,
//     tabActiveColor: comm.color.cffff,
//     tabActiBg: base.color.c0002,
//   },
// };
const tabTheme = {};

for (const item of Object.keys(brandCodeMap)) {
  tabTheme[item] = {
    tabs: {
      navBgc: base[item]?.tabColor.c0023,
      tabColor: base[item]?.tabColor.c0014,
      tabActiveColor: comm.color.cffff,
      tabActiBg: base[item]?.tabColor.c0002,
      tabBackFff: comm.color.cffff,
    },
  };
}

export const tabs = tabTheme;
